import { useMemo } from 'react'
import { KeyValuePairs } from 'components/ideal-core-ui'
import { FaCircle } from 'react-icons/fa'
import { getPriorityColor, timezoneDate } from 'utils/helpers'
import { Container, Row, Col } from 'reactstrap'
import s from './GeneralInfo.scss'

const getPairs = values => {
  const {
    cellPhone,
    phone,
    email,
    status,
    priority,
    birthday,
    partner,
    partnerBirthday,
    label,
    phoneExt,
    fax,
    accountOwner
  } = values
  const pairs = []

  cellPhone &&
    pairs.push({
      key: 'Phone (cell):',
      value: <span>{cellPhone}</span>
    })
  phone &&
    pairs.push({
      key: 'Phone (office):',
      value: <span>{phone}</span>
    })
  phoneExt &&
    pairs.push({
      key: 'Ext.:',
      value: <span>{phoneExt}</span>
    })
  fax &&
    pairs.push({
      key: 'Fax:',
      value: <span>{fax}</span>
    })
  email &&
    pairs.push({
      key: 'Email:',
      value: <span>{email}</span>
    })
  label &&
    pairs.push({
      key: 'Labels:',
      value: <span>{label}</span>
    })
  status &&
    pairs.push({
      key: 'Status:',
      value: <span>{status.name}</span>
    })
  priority &&
    pairs.push({
      key: 'Priority:',
      value: (
        <div className={s.priority}>
          <FaCircle className={s.priority} style={{ color: getPriorityColor(priority) }} />
          <span className={s.capitalize}>{priority}</span>
        </div>
      )
    })
  accountOwner &&
    pairs.push({
      key: 'Contact Owner:',
      value: <span>{accountOwner.userName}</span>
    })
  birthday &&
    pairs.push({
      key: 'Contact Birthday:',
      value: <span>{timezoneDate(birthday)}</span>
    })
  partner &&
    pairs.push({
      key: 'Spouse/Partner Name:',
      value: <span>{partner}</span>
    })
  partnerBirthday &&
    pairs.push({
      key: 'Spouse/Partner Birthday:',
      value: <span>{timezoneDate(partnerBirthday)}</span>
    })

  return pairs
}

const GeneralInfo = ({
  cellPhone,
  phone,
  phoneExt,
  email,
  priority,
  birthday,
  partner,
  partnerBirthday,
  status,
  label,
  fax,
  accountOwner
}) => {
  // eslint-disable-next-line react-hooks/exhaustive-deps
  const leftPairs = useMemo(
    () =>
      getPairs({
        cellPhone,
        phone,
        phoneExt,
        fax,
        email,
        label
      }),
    [cellPhone, phone, email, phoneExt, fax, label]
  )
  // eslint-disable-next-line react-hooks/exhaustive-deps
  const rightPairs = useMemo(
    () =>
      getPairs({
        status,
        priority,
        accountOwner,
        birthday,
        partner,
        partnerBirthday
      }),
    [status, priority, birthday, partner, partnerBirthday, accountOwner]
  )

  return (
    <section className={s.generalInfoContainer}>
      <Container>
        <Row>
          <Col lg="6">
            <KeyValuePairs pairs={leftPairs} />
          </Col>
          <Col lg="6">
            <KeyValuePairs pairs={rightPairs} />
          </Col>
        </Row>
      </Container>
    </section>
  )
}

export default GeneralInfo
